export const SESSION_STORAGE_KEYS = {
  LOGIN_FORM_VALUE: 'formValues',
  PASSWORD_RESET_FORM_VALUE: 'resetFormValues',
};

export enum STORAGE_TOKEN_KEY {
  ClientId = 'client-id',
  UserId = 'user-id',
}

export const COOKIE_STORAGE_KEYS = {
  CLIENT_ID: 'client-id',
  IP_ADDRESS: 'ip-address',
  SHOW_TIMER: 'showTimer',
  BLOCKED_TIME_SIGNAL: 'blockedTimeSignal',
  SHOW_ERROR: 'showError',
  TIME_STAMP: 'timestamp',
  USER_ID: 'user-id',
  TEMPLATE_ID: 'template-id',
  ACCESS_TOKEN: 'X-Access-Token',
};

export enum LOCAL_STORAGE_KEYS {
  CLIENT_ID = 'client-id',
  LANGUAGE = 'language',
  FEATURE_VISIBILITY = 'feature-visibility',
  CURRENT_DRAG_DATA = 'currentDragElement',
  IS_THIRD_PARTY = 'isThirdParty',
  USER_LEVEL = 'userLevel',
}
